import agbFormCz from './cz.json';
import agbFormDe from './de.json';
import agbFormFr from './fr.json';
import agbFormUs from './us.json';
import agbFormVn from './vn.json';

import agbDialogCz from '../../agb-dialog/i18n/cz.json';
import agbDialogDe from '../../agb-dialog/i18n//de.json';
import agbDialogFr from '../../agb-dialog/i18n//fr.json';
import agbDialogUs from '../../agb-dialog/i18n//us.json';
import agbDialogVn from '../../agb-dialog/i18n//vn.json';

export class AgbFormLocalization {
  public static getCzLanguageSet() {
    return {
      ...agbFormCz,
      ...agbDialogCz,
    };
  }

  public static getDeLanguageSet() {
    return {
      ...agbFormDe,
      ...agbDialogDe,
    };
  }

  public static getFrLanguageSet() {
    return {
      ...agbFormFr,
      ...agbDialogFr,
    };
  }

  public static getUsLanguageSet() {
    return {
      ...agbFormUs,
      ...agbDialogUs,
    };
  }

  public static getVnLanguageSet() {
    return {
      ...agbFormVn,
      ...agbDialogVn,
    };
  }
}
